import moment from "moment";
import React, {Component} from "react";
import {connect} from "react-redux";
import {toast} from "react-toastify";
import {NewInventoryProduct, UtilitiesEmployee,} from "../../../redux/actions/Modules.Action";
import {
    removeStockParticular,
    setDefaultStockData,
    StockAddParticular,
    StockChangeHandler,
} from "../../../redux/actions/Stock.Action";
import ApiConnect from "../../../Utils/ApiConnect";
import AutoComplete from "../../Components/AutoComplete";
import BarcodeScanner from "../../Components/BarcodeScanner";

class StockDeduction extends Component {
  constructor() {
    super();
    this.state = {
      particularItems: {
        id: "",
        name: "",
        qty: 0,
        damage: 0,
        remark: "",
      },
      formError: false,
      btnDisable: false,
      reset: false,
    };
  }

  componentDidMount() {
    this.props.setDefaultStockData();
    this.FetchFieldData();
  }
  FetchFieldData = () => {
    ApiConnect.get(`/Module/Utilities/Employee/Details`)
      .then((response) => {
        let Employee = response.data;
        this.props.UtilitiesEmployee(Employee);
      })
      .catch((error) => {
        console.log(error);
      });
    ApiConnect.get("/Module/Inventory/Product/Details")
      .then((response) => {
        let Products = response.data;
        this.props.NewInventoryProduct(Products);
      })
      .catch((error) => {
        console.log(error);
      });
  };
  addNewRow = (e) => {
    e.preventDefault();
    this.props.StockAddParticular(this.state.particularItems);
    this.setState({
      particularItems: {
        id: "",
        name: "",
        qty: 0,
        damage: 0,
        remark: "",
      },
      reset: true,
    });
  };
  handleBarCodeScan = async (e) => {
    if (e) {
      let particularItems = []
      particularItems["id"] = e.id;
      particularItems["name"] = e.name
      particularItems["qty"] = 1
      particularItems["damage"] = 0
      particularItems["expire"] = "0000-00-00"
      this.props.StockAddParticular(particularItems);
    }
  }
  handleChange = (e) => {
    let particularItems = { ...this.state.particularItems };
    if (e.target) {
      particularItems[e.target.name] = e.target.value;
    } else {
      particularItems["id"] = e.id;
      particularItems["name"] = e.name;
    }
    this.setState({ particularItems: particularItems });
  };
  handleSubmit(e) {
    e.preventDefault();
    this.setState({ btnDisable: true });
    var Fdata = new FormData();
    let cnt = 0;
    const prdData = this.props.particulars;
    while (prdData.length > cnt) {
      Fdata.append("product[]", prdData[cnt].id);
      Fdata.append("qty[]", prdData[cnt].qty);
      Fdata.append("damage[]", prdData[cnt].damage);
      Fdata.append("remark[]", prdData[cnt].remark);
      cnt++;
    }
    Fdata.append(
      "date",
      this.props.stock.date
        ? moment(this.props.stock.date).format("Y-MM-DD")
        : ""
    );
    Fdata.append("note", this.props.stock.note);
    Fdata.append("employee", this.props.stock.employee);
    ApiConnect({
      method: "post",
      url: "/Module/Inventory/Stock/StockDeduction",
      data: Fdata,
    })
      .then((response) => {
        this.setState({ btnDisable: false });
        if (response.data.status === 406) {
          this.setState({ formError: response.data.message });
        } else if (response.data.status === 201) {
          this.setState({
            particularItems: {
              id: "",
              name: "",
              qty: 0,
              damage: 0,
              remark: "",
            },
            reset: true,
          });
          this.props.setDefaultStockData();
          toast.success(response.data.message, {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            draggableDirection: "y",
          });
        } else if (response.data.status) {
          toast.danger(response.data.message, {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            draggableDirection: "y",
          });
        }
      })
      .catch((error) => console.log(error));
  }
  handleEmployee = (data) => {
    this.setState({ employee: data.id });
    this.props.StockChangeHandler(data.id, "employee");
  };
  render() {
    return (
      <div className="card">
        <h5 className="card-header">Stock Deduction</h5>
        <div className="card-body">
          <div className="row invoice-info" id="subcat"></div>
          <div className="row">
            <div className="col-md-3 ml-md-auto text-right">
              <label>Date</label>
              <input
                type="date"
                className="form-control"
                name="date"
                onChange={(e) => this.props.StockChangeHandler(e)}
              />
            </div>
            <div className="col-md-3 ml-md-auto text-right">
              <label>Employee</label>
              {this.props.employee.length !== 0 ? (
                <AutoComplete
                  action={this.handleEmployee}
                  name="employee"
                  placeHolder="Employee"
                  styleName=""
                  items={this.props.employee}
                />
              ) : (
                ""
              )}
            </div>
            <div className="col-md-6">
              <label>Note</label>
              <textarea
                size="50"
                name="note"
                className="form-control w-100 text-muted"
                placeholder="Note/Remark Here"
                onChange={(e) => this.props.StockChangeHandler(e)}
              ></textarea>
            </div>
            <p className="text-danger">{this.state.formError}</p>
            <BarcodeScanner fallback={this.handleBarCodeScan} />
            <div className="col-xs-12 table">
              <table className="table table-separated table-sm">
                <thead>
                  <tr>
                    <th>SN</th>
                    <th>Product</th>
                    <th>Qty</th>
                    <th>Damage Qty</th>
                    <th>remark</th>
                    <th></th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td></td>
                    <td>
                      {this.props.products.length !== 0 ? (
                        <AutoComplete
                          action={this.handleChange}
                          name="product"
                          placeHolder="Product Name"
                          styleName=""
                          items={this.props.products}
                        />
                      ) : (
                        ""
                      )}
                    </td>
                    <td>
                      <form onSubmit={(e) => this.addNewRow(e)}>
                        <input
                          type="number"
                          onChange={(e) => this.handleChange(e)}
                          value={this.state.particularItems.qty}
                          step="0.01"
                          name="qty"
                          className="form-control"
                          required
                        />
                      </form>
                    </td>
                    <td>
                      <form onSubmit={(e) => this.addNewRow(e)}>
                        <input
                          type="number"
                          value={this.state.particularItems.damage}
                          step="0.01"
                          onChange={(e) => this.handleChange(e)}
                          name="damage"
                          className="form-control"
                          required
                        />
                      </form>
                    </td>
                    <td>
                      <form onSubmit={(e) => this.addNewRow(e)}>
                        <input
                          type="text"
                          name="remark"
                          value={this.state.particularItems.remark}
                          onChange={(e) => this.handleChange(e)}
                          className="form-control"
                        />
                      </form>
                    </td>
                    <td>
                      <button
                        className="btn btn-square btn-danger"
                        onClick={(e) => this.addNewRow(e)}
                      >
                        <span className="material-icons-outlined">add</span>
                      </button>
                    </td>
                  </tr>
                  {this.props.particulars.length !== 0
                    ? this.props.particulars.map((items, index) => (
                      <tr key={index}>
                        <td></td>
                        <td>{items.name}</td>
                        <td>{items.qty}</td>
                        <td>{items.damage}</td>
                        <td>{items.remark}</td>
                        <td>
                          <button
                            className="btn btn-square btn-danger"
                            onClick={() =>
                              this.props.removeStockParticular(items)
                            }
                          >
                            <span className="material-icons-outlined">
                              clear
                            </span>
                          </button>
                        </td>
                      </tr>
                    ))
                    : ""}
                </tbody>
              </table>
            </div>
          </div>
          <footer className="card-footer text-right">
            <button
              className="btn btn-success"
              type="submit"
              disabled={this.state.btnDisable}
              onClick={(e) => this.handleSubmit(e)}
            >
              Submit
            </button>
          </footer>
        </div>
      </div>
    );
  }
}
export default connect(
  (state) => ({
    products: state.Inventory.Products,
    employee: state.Utilities.Employee,
    stock: state.Stock.Entry,
    particulars: state.Stock.Entry.particulars,
  }),
  {
    NewInventoryProduct,
    UtilitiesEmployee,
    StockChangeHandler,
    StockAddParticular,
    removeStockParticular,
    setDefaultStockData,
  }
)(StockDeduction);
